import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'

// Danish Pages
import Home from './pages/Home'
import LovpakkePriser from './pages/LovpakkePriser'
import TeoriUndervisning from './pages/TeoriUndervisning'
import Opstart from './pages/Opstart'
import ValgAfKoereskole from './pages/ValgAfKoereskole'
import OmOs from './pages/OmOs'
import Anbefalinger from './pages/Anbefalinger'
import Betingelser from './pages/Betingelser'
import Links from './pages/Links'
import Kontakt from './pages/Kontakt'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

// English Pages
import HomeEn from './pages/en/HomeEn'
import LovpakkePriserEn from './pages/en/LovpakkePriserEn'
import TeoriUndervisningEn from './pages/en/TeoriUndervisningEn'
import OpstartEn from './pages/en/OpstartEn'
import ValgAfKoereskoleEn from './pages/en/ValgAfKoereskoleEn'
import OmOsEn from './pages/en/OmOsEn'
import AnbefalingerEn from './pages/en/AnbefalingerEn'
import BetingelserEn from './pages/en/BetingelserEn'
import LinksEn from './pages/en/LinksEn'
import KontaktEn from './pages/en/KontaktEn'
import NotFoundPageEn from './pages/en/NotFoundPageEn'
import ForbiddenPageEn from './pages/en/ForbiddenPageEn'

export default function App() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-slate-50 text-slate-800 antialiased selection:bg-emerald-500 selection:text-white">
      <ScrollToTop />
      <Header />
      
      <main className="flex-grow">
        <Routes>
          {/* Danish Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/lovpakke-priser" element={<LovpakkePriser />} />
          
          {/* Teori & Undervisning routes */}
          <Route path="/teori-undervisning" element={<TeoriUndervisning />} />
          <Route path="/opstart" element={<Opstart />} />
          <Route path="/valg-af-koereskole" element={<ValgAfKoereskole />} />

          {/* Om os & Betingelser */}
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/betingelser" element={<Betingelser />} />

          {/* Anbefalinger, Links & Kontakt */}
          <Route path="/anbefalinger" element={<Anbefalinger />} />
          <Route path="/links" element={<Links />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* Error pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />

          {/* English Routes */}
          <Route path="/en" element={<HomeEn />} />
          <Route path="/en/mandatory-package-prices" element={<LovpakkePriserEn />} />
          
          {/* Theory & Instruction routes */}
          <Route path="/en/theory-instruction" element={<TeoriUndervisningEn />} />
          <Route path="/en/getting-started" element={<OpstartEn />} />
          <Route path="/en/choosing-a-driving-school" element={<ValgAfKoereskoleEn />} />

          {/* About us & Terms */}
          <Route path="/en/about-us" element={<OmOsEn />} />
          <Route path="/en/terms" element={<BetingelserEn />} />

          {/* Testimonials, Links & Contact */}
          <Route path="/en/testimonials" element={<AnbefalingerEn />} />
          <Route path="/en/links" element={<LinksEn />} />
          <Route path="/en/contact" element={<KontaktEn />} />

          {/* English Error pages */}
          <Route path="/en/403" element={<ForbiddenPageEn />} />
          <Route path="/en/404" element={<NotFoundPageEn />} />

          {/* Fallback */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  )
}
